<template>
    <el-container style="padding: 0px;min-height: 100vh;margin: 0;" @click="clicked">
        <el-header height="100px" class="header">
            <Header></Header>
        </el-header>
        <el-container class="container">
            <el-aside style="background-color: rgb(0,21,41);" class="navmenu" width="auto">
                <NavMenu ></NavMenu>
            </el-aside>
            <el-main style="background-color: rgb(240,242,245);display: flex;flex: 1;">
                <ContentMain></ContentMain>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import Header from '@/components/layout/Header.vue'
import NavMenu from '@/components/layout/NavMenu.vue'
import ContentMain from '@/components/layout/ContentMain.vue'
export default {
  name: 'Home',
  data () {
    return {
      lTime: new Date().getTime(), // 最后一次点击的时间
      cTime: new Date().getTime(), // 当前时间
      // tOut: 60 * 10 * 1000,   // 超时时间10min
      tOut: 60 * 1000 * 60,
      t1: ''
    }
  },
  mounted () {
    this.t1 = setInterval(this.tTime, 1000)
  },
  beforeDestroy () {
    // 最后一步，离开页面的时候，清除一下定时器，也解绑点击事件
    clearInterval(this.t1)
  },
  components: {
    Header,
    NavMenu,
    ContentMain
  },
  methods: {
    clicked () {
      // 当界面被点击更新点击时间
      this.lTime = new Date().getTime()
    },
    tTime () {
      this.cTime = new Date().getTime()
      if (this.cTime - this.lTime > this.tOut) {
        // 未登录状态
        console.log('当前时间:' + this.cTime + '最后点击时间：' + this.lTime + '延时:' + this.tOut)
        if (sessionStorage.getItem('username') == null) {
          this.lTime = new Date().getTime()
        } else {
          this.equit()
        }
      }
    },
    equit (command) {
      let val = {
        username: sessionStorage.getItem('username')
      }
      this.$http.post('/api/v2.1/admin/logout', val).then(res => {
        // console.log(res)
        if (res.status === 200) {
          if (res.data.error === 0) {
            console.log('退出成功')
            sessionStorage.removeItem('username')
            this.$router.push('/login')
            // console.log('进来了')
            this.$alert('超过六十分钟未操作系统，已自动退出，请重新登录', '提示', {
              confirmButtonText: '确定'
            })
          } else {
            console.log('退出失败')
            setTimeout(() => {
              this.equit()
            }, 5000)
          }
        } else {
          console.log('no')
          setTimeout(() => {
            this.equit()
          }, 5000)
        }
      })
    }
  }
}
</script>

<style scoped>
.header {
    padding: 0px;
}
.container{
    padding: 0px;
    overflow: hidden;
}
.navmenu {
    margin-top: 0px;
    overflow: hidden;
    width: 100%;
    display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Home.vue